<template>
  <router-view />
</template>

<style>
@import 'normalize.css/normalize.css' layer(reset);
@import '@transfeeradev/bridge/dist/style.css';
@import './plugins/toaster/toaster.css';

html {
  font-family: Nunito, Arial, sans-serif;
  font-size: 16px;
  color: var(--bg-grey-dark);
}
</style>
